module.exports = __webpack_public_path__ + "static/media/like.2c019796.svg";